import Icon from "@ant-design/icons";
const BackArrowSvg = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.0001 30.3332C8.09342 30.3332 1.66675 23.9065 1.66675 15.9998C1.66675 8.09317 8.09342 1.6665 16.0001 1.6665C23.9067 1.6665 30.3334 8.09317 30.3334 15.9998C30.3334 23.9065 23.9067 30.3332 16.0001 30.3332ZM16.0001 3.6665C9.20008 3.6665 3.66675 9.19984 3.66675 15.9998C3.66675 22.7998 9.20008 28.3332 16.0001 28.3332C22.8001 28.3332 28.3334 22.7998 28.3334 15.9998C28.3334 9.19984 22.8001 3.6665 16.0001 3.6665Z"
      fill="#31493C"
    />
    <path
      d="M20.6667 17H12.6667C12.1201 17 11.6667 16.5467 11.6667 16C11.6667 15.4533 12.1201 15 12.6667 15H20.6667C21.2134 15 21.6667 15.4533 21.6667 16C21.6667 16.5467 21.2134 17 20.6667 17Z"
      fill="#31493C"
    />
    <path
      d="M15.3333 21.0001C15.08 21.0001 14.8267 20.9068 14.6267 20.7067L10.6267 16.7068C10.24 16.3201 10.24 15.6801 10.6267 15.2934L14.6267 11.2934C15.0133 10.9068 15.6533 10.9068 16.04 11.2934C16.4267 11.6801 16.4267 12.3201 16.04 12.7068L12.7467 16.0001L16.04 19.2934C16.4267 19.6801 16.4267 20.3201 16.04 20.7067C15.84 20.9068 15.5867 21.0001 15.3333 21.0001Z"
      fill="#31493C"
    />
  </svg>
);

const BackArrowIcon = (props) => <Icon component={BackArrowSvg} {...props} />;

export default BackArrowIcon;
